import { CurrentClub } from './api-types';

/** PUT /player/currentClub/edit/:playerId reads data.id as the team id. */
export const toCurrentClubEditBody = (
  updatedCurrentClub: CurrentClub,
  teamId: string
): CurrentClub => ({
  ...updatedCurrentClub,
  id: teamId,
});
